import type { JSONValue } from '@common/interfaces/customControlData';
import { BMICategories } from '@common/enums';
import { concatOrNull } from './textUtils';

export function calculateBmi(weight: number | null, length: number | null): string {
    if (weight && length) {
        const bmi = weight / ((length / 100) * (length / 100));

        return bmi.toLocaleString('nl-NL', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    } else {
        return '';
    }
}

export function getCalculatedBmiAsNumber(weight: number | null, length: number | null): number | undefined {
    if (weight && length) {
        return Math.round((weight / ((length / 100) * (length / 100))) * 100) / 100;
    } else {
        return undefined;
    }
}

export function getBmiCategorie(bmi: number): string {
    if (bmi < 18.5) {
        return BMICategories.underweight;
    }
    if (bmi < 25) {
        return BMICategories.normalWeight;
    }
    if (bmi < 27) {
        return BMICategories.slightlyOverweight;
    }
    if (bmi < 30) {
        return BMICategories.moderatelyOverweight;
    }
    if (bmi < 40) {
        return BMICategories.severelyOverweight;
    }

    return BMICategories.verySeverelyOverweight;
}

export function setWeightLengthBmiInReadSectionMap(args: {
    bmi?: number | null;
    lengthInCm: number | null;
    map: Map<string, JSONValue>;
    weightInKg: number | null;
}) {
    const { weightInKg, lengthInCm, map } = args;

    const bmi = weightInKg && lengthInCm ? calculateBmi(weightInKg, lengthInCm) : args.bmi;

    map.set('weight_length_bmi', [
        concatOrNull(weightInKg, 'kg'),
        concatOrNull(lengthInCm, 'cm'),
        concatOrNull(bmi, 'kg/m2'),
    ]);

    return map;
}
